import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthService from '../services/AuthService';
import { useAuthErrorHandler } from '../hooks/useAuthErrorHandler';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'admin' | 'superadmin';
}

/**
 * Protected Route Component
 * Checks authentication and optionally role-based access
 * Redirects to /admin/login if token expires or is invalid
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  // Listen for authentication errors from API calls
  useAuthErrorHandler();

  const isAuthenticated = AuthService.isAuthenticated();
  // Not authenticated - redirect to login page
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  // Check role if required
  if (requiredRole) {
    if (requiredRole === 'admin' && !AuthService.isAdmin()) {
      return <Navigate to="/admin/login" replace />;
    }
    if (requiredRole === 'superadmin' && !AuthService.isSuperAdmin()) {
      return <Navigate to="/admin/login" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
